import FirebaseLogin from './login/FirebaseLogin'
import JwtLogin from './login/JwtLogin'
import NotFound from './NotFound'
import ForgotPassword from './ForgotPassword'
import FirebaseRegister from './register/FirebaseRegister'
import LoonsLogin from './login/LoonsLogin'
const sessionRoutes = [
    {
        path: '/session/signup',
        component: FirebaseRegister,
    },
    {
        path: '/session/signin',
        component: LoonsLogin,
    },
    /* {
        path: '/session/signinTemp',
        component: LoonsLogin,
    }, */
    {
        path: '/session/forgot-password',
        component: ForgotPassword,
    },
    {
        path: '/session/404',
        component: NotFound,
    },
]

export default sessionRoutes
